export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
export const USER_LOGOUT = 'USER_LOGOUT';

export default {
  USER_LOGIN,
  USER_LOGIN_ERROR,
  USER_LOGOUT,
};



// WEBPACK FOOTER //
// ./src/actions/mutations.js